import mirrorCreator from 'mirror-creator';
import { createActions } from 'redux-actions';

const actionTypes = mirrorCreator([
  'REWARDS_REQUEST',
  'REWARDS_SUCCESS',
  'REWARDS_FAILURE',
  'REWARD_DETAILS_REQUEST',
  'REWARD_DETAILS_SUCCESS',
  'REWARD_DETAILS_FAILURE',
  'WITHDRAWALS_REQUEST',
  'WITHDRAWALS_SUCCESS',
  'WITHDRAWALS_FAILURE',
]);

const actionCreators = createActions(
  {
    [actionTypes.REWARD_DETAILS_REQUEST]: (unlockingDate) => ({ unlockingDate }),
    [actionTypes.REWARDS_FAILURE]: Error,
    [actionTypes.REWARD_DETAILS_FAILURE]: Error,
    [actionTypes.WITHDRAWALS_FAILURE]: Error,
  },
  actionTypes.REWARDS_REQUEST,
  actionTypes.REWARDS_SUCCESS,
  actionTypes.REWARD_DETAILS_SUCCESS,
  actionTypes.WITHDRAWALS_REQUEST,
  actionTypes.WITHDRAWALS_SUCCESS
);

export default {
  ...actionTypes,
  ...actionCreators,
};

